/** S3 key prefix for uploaded `.avlr` transfer packages (same bucket as every other FVS upload). */
export const DATA_TRANSFER_IMPORT_KEY_PREFIX = "data-transfer/import";

/**
 * Destination S3 key sent to FVS as `destinationS3Key` (via the uploader's
 * `modifyDestinationFileKey`). Scoped by account, with a unique segment so re-uploading a package
 * with the same name never overwrites an earlier one. The service reads the package back using
 * the `key` FVS returns, so this only decides where in the shared bucket the file lands.
 *
 * Throws when there is no account id rather than bucketing uploads under a shared fallback prefix:
 * the panel only renders the uploader once a session account id is known, so this never fires in
 * practice and guards against a regression that would mix accounts under one key path.
 */
export const buildDataTransferImportKey = (
    accountId: string | number | null | undefined,
    fileName: string
): string => {
    if (accountId === null || accountId === undefined || accountId === "") {
        throw new Error("Cannot build a data-transfer import key without an account id.");
    }
    const safeName = fileName.replace(/[^A-Za-z0-9._-]/g, "_");
    return `${DATA_TRANSFER_IMPORT_KEY_PREFIX}/${accountId}/${crypto.randomUUID()}/${safeName}`;
};
